<template>
    <div v-if="xs" class="d-flex">
        <tool-button v-if="folders.length > 1" icon="arrow-left" @click="navigate(folders[folders.length - 2])">
        </tool-button>
        <div v-ripple v-if="folders.length > 0" class="drive-navigation-item">
            <div class="drive-navigation-text">
                {{ folders[folders.length - 1].name }}
            </div>
            <dropdown-menu :actions="actions" />
        </div>
    </div>
    <ol v-else class="drive-navigation">
        <li v-ripple v-if="folders.length > 2" class="drive-navigation-item" @click="navigate(folders[0])">
            <div class="drive-navigation-text">{{ folders[0].name }}</div>
        </li>
        <li v-ripple v-if="folders.length > 2" class="drive-navigation-item">
            <div id="navigation_first" @click="fetchFirstFolders">
                <tool-icon name="chevron-right" />
            </div>
            <dropdown-menu id="navigation_first" :actions="firstFolders" />
        </li>
        <li v-ripple v-if="folders.length > 1" class="drive-navigation-item"
            @click="folders.length > 3 ? undefined : navigate(folders[folders.length - 2])">
            <div id="navigation_middle" class="drive-navigation-text">
                {{ folders.length > 3 ? '...' :  folders[folders.length - 2].name }}
            </div>
            <dropdown-menu v-if="folders.length > 3" id="navigation_middle" :actions="middleFolders" />
        </li>
        <li v-ripple v-if="folders.length > 1" class="drive-navigation-item">
            <div id="navigation_last" @click="fetchLastFolders">
                <tool-icon name="chevron-right" />
            </div>
            <dropdown-menu id="navigation_last" :actions="lastFolders" />
        </li>
        <li v-ripple v-if="folders.length > 0" class="drive-navigation-item active">
            <div class="drive-navigation-text" id="navigation_overflow">
                {{ folders[folders.length - 1].name }}
            </div>
            <dropdown-menu id="navigation_overflow" :actions="actions" />
        </li>
    </ol>
</template>

<script>
import DropdownMenu from '@topomatic/tap/src/components/DropdownMenu.vue';
import ToolIcon from '@topomatic/tap/src/components/ToolIcon.vue';
import ToolButton from '@topomatic/tap/src/components/ToolButton.vue';
import AppConsts from '../consts';

export default {
    components: {
        DropdownMenu,
        ToolIcon,
        ToolButton,
    },
    name: 'FolderNavigation',
    props: {
        folders: Array,
        onCreateFolder: Function,
        onUploadFolder: Function,
        onUploadFile: Function,
    },
    data() {
        return {
            fetch_last_folders_clicked: false,
            last_folders_data: [],
            fetch_first_folders_clicked: false,
            first_folders_data: [],
        };
    },
    computed: {
        actions() {
            return [{
                title: this.$tr('Создать папку'),
                icon: 'folder-plus',
                onclick: this.onCreateFolder,
            }, {
                title: '-',
            }, {
                title: this.$tr('Загрузить файлы'),
                icon: 'file-plus',
                onclick: this.onUploadFile,
            }, {
                title: this.$tr('Загрузить папку'),
                icon: 'folder',
                onclick: this.onUploadFolder,
            }];
        },
        middleFolders() {
            const actions = [];
            const { folders } = this;
            if (folders.length > 3) {
                for (let i = 1; i < folders.length - 1; i++) {
                    actions.push({
                        title: folders[i].name,
                        icon: 'folder',
                        id: folders[i].id,
                        onclick: this.navigate,
                    });
                }
            }
            return actions;
        },
        lastFolders() {
            return this.getLastFolders();
        },
        firstFolders() {
            return this.getFirstFolders();
        },
        display() {
            return this.$vuetify.display;
        },
        xs() {
            return this.display.xs;
        },
    },
    methods: {
        getFirstFolders() {
            if (this.fetch_first_folders_clicked) {
                this.$api.getFiles(this.folders[0].id)
                    .then((data) => {
                        const folders = [];
                        for (let i = 0; i < data.files.length; i++) {
                            const file = data.files[i];
                            if (file.type == AppConsts.FOLDER_TYPE) {
                                folders.push(file);
                            }
                        }
                        folders.sort((a, b) => (a.name < b.name ? -1 : 1));
                        this.fetch_first_folders_clicked = false;
                        this.first_folders_data = folders;
                    });
                return [{
                    title: this.$tr('Загрузка...'),
                    icon: 'sync',
                }];
            }
            const actions = [];
            for (let i = 0; i < this.first_folders_data.length; i++) {
                actions.push({
                    title: this.first_folders_data[i].name,
                    icon: 'folder',
                    id: this.first_folders_data[i].id,
                    onclick: this.navigate,
                });
            }
            return actions;
        },
        getLastFolders() {
            if (this.fetch_last_folders_clicked) {
                this.$api.getFiles(this.folders[this.folders.length - 2].id)
                    .then((data) => {
                        const folders = [];
                        for (let i = 0; i < data.files.length; i++) {
                            const file = data.files[i];
                            if (file.type == AppConsts.FOLDER_TYPE) {
                                folders.push(file);
                            }
                        }
                        folders.sort((a, b) => (a.name < b.name ? -1 : 1));
                        this.fetch_last_folders_clicked = false;
                        this.last_folders_data = folders;
                    });
                return [{
                    title: this.$tr('Загрузка...'),
                    icon: 'sync',
                }];
            }
            const actions = [];
            for (let i = 0; i < this.last_folders_data.length; i++) {
                actions.push({
                    title: this.last_folders_data[i].name,
                    icon: 'folder',
                    id: this.last_folders_data[i].id,
                    onclick: this.navigate,
                });
            }
            return actions;
        },
        fetchLastFolders() {
            this.fetch_last_folders_clicked = true;
        },
        fetchFirstFolders() {
            this.fetch_first_folders_clicked = true;
        },
        navigate(context) {
            this.$emit('navigate', context.id);
        },
    },
    watch: {
        folders() {
            this.fetch_last_folders_clicked = false;
            this.last_folders_data = [];
            this.fetch_first_folders_clicked = false;
            this.first_folders_data = [];
        },
    },
};
</script>

<style scoped>
.drive-navigation {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    list-style: none;
    border-radius: 0.35rem;
    padding: 0;
    margin: 0;
    line-height: 1;
}
.drive-navigation-item {
    cursor: pointer;
    border-radius: 0.5rem;
    color: rgb(var(--v-theme-surface-variant)) !important;
    align-self: center;
}
.drive-navigation-item.active {
    color: rgb(var(--v-theme-on-surface)) !important;
    font-weight: bold;
}
.drive-navigation-item:hover {
    background: rgb(var(--v-theme-on-surface-variant)) !important;
}
.drive-navigation-text {
    padding: 0.8rem;
}
</style>
